import React, { useEffect, useState } from 'react'
import "./Subcategory.css"
import { Link, useLocation, useParams } from 'react-router-dom'
import CategoriesData from '../Products/CategoriesData'

const Subcategory = (props) => {

  /* global dataLayer */
  const location = useLocation();

  useEffect(() => {
    document.title = props.title;

    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute("href", canonicalUrl);
    } else {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const description = props.descriptions;
    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      metaDescription.setAttribute("content", description);
      document.head.appendChild(metaDescription);
    }
  }, [props.title, props.descriptions, location.pathname]);

  const { pathName } = useParams();

  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await CategoriesData
        const data = response;
        const subcategories = data.reduce((acc, category) => acc.concat(category.subcategories), []);
        setApiData(subcategories);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatPathname = (pathName) => {
    return pathName.toLowerCase().replace(/\s+/g, '-');
  };
  const subcategory = apiData?.find(sub => formatPathname(sub.subcategory) === pathName);
  // console.log(subcategory, "got the data of product")

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };

  const extractVideoId = (link) => {
    try {
      const url = new URL(link);
      const id = url.searchParams.get("v");
      if (id) return id;
      if (url.hostname === "youtu.be") return url.pathname.slice(1);
      if (link.includes("embed/")) return link.split("embed/")[1]?.split("?")[0];
    } catch {
      return "";
    }
    return "";
  };

  return (
    <div className='Subcategory'>
      {loading ? (
        <div className="loader">
          <div className="spinner-grow" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        subcategory && (
          <>
            <div className='Subcategory-banner'>
              <img src={subcategory.cover} alt="" />
            </div>
            <div className='Subcategory-main'>
              <div className='Subcategory-card'>
                <div className='Subcategory-box'>

                  <div className='Subcategory-right'>
                    <div className="subcategory-title">

                      <img src={subcategory.brand} alt="" />
                      <h1>{subcategory.subcategory}</h1>
                      <ul>
                        {subcategory.headingbulletpo && subcategory.headingbulletpo.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <h6><strong>{boldPart}</strong>{rest.join(':')}</h6>
                            </li>
                          );
                        })}
                      </ul>
                    </div>

                    <h4>{subcategory.title}</h4>

                    <h5>{subcategory.title20h}</h5>
                    <h5>{subcategory.headingbulets}</h5>
                    <strong> <h3>{subcategory.subtitle001}</h3></strong>
                    <p>{subcategory.description}</p>
                    <ul>
                      {subcategory.bulletPoints0spunch && subcategory.bulletPoints0spunch.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong> {rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <p>{subcategory.subdesc1}</p>
                    <p>{subcategory.description12}</p>
                    <p>{subcategory.subdescsvt}</p>
                    <p>{subcategory.descriptionsvt}</p>



                    <h3>{subcategory.subtitle}</h3>
                    <p>{subcategory.pragHead}</p>
                    <h3>{subcategory.subHead1}</h3>
                    <p>{subcategory.description12}</p>
                    <p>{subcategory.pragHead1}</p>
                    <h3>{subcategory.subtitle01}</h3>
                    <p>{subcategory.description01}</p>
                    <p>{subcategory.description02}</p>
                    <p>{subcategory.description03}</p>
                    <h3>{subcategory.subtitle12}</h3>

                    <h4><strong>{subcategory.heading01}</strong></h4>
                    <p>{subcategory.pragraphp01}</p>
                    <h4><strong>{subcategory.subtitle102}</strong></h4>

                    <ul>
                      {subcategory.bulletPoints102 && subcategory.bulletPoints102.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <>{boldPart}</>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h5>{subcategory.subtitle1rha}</h5>

                    <ul>
                      {subcategory.bulletPoints1rha && subcategory.bulletPoints1rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>
                    <h5>{subcategory.subtitle2rha}</h5>

                    <ul>
                      {subcategory.bulletPoints2rha && subcategory.bulletPoints2rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h5>{subcategory.subtitle3rha}</h5>

                    <ul>
                      {subcategory.bulletPoints3rha && subcategory.bulletPoints3rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>


                    <h5>{subcategory.subtitle4rha}</h5>
                    <ul>
                      {subcategory.bulletPoints4rha && subcategory.bulletPoints4rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h5>{subcategory.subtitle5rha}</h5>

                    <ul>
                      {subcategory.bulletPoints5rha && subcategory.bulletPoints5rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h5>{subcategory.subtitle6rha}</h5>
                    <ul>
                      {subcategory.bulletPoints6rha && subcategory.bulletPoints6rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>
                    <h5>{subcategory.subtitle7rha}</h5>

                    <ul>
                      {subcategory.bulletPoints7rha && subcategory.bulletPoints7rha.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart} :</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <ul>
                      {subcategory.bulletPoints12 && subcategory.bulletPoints12.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <p>{boldPart}</p>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h4><strong>{subcategory.subtitle192}</strong></h4>


                    <ul>
                      {subcategory.bulletPoints192 && subcategory.bulletPoints192.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <strong>{boldPart}</strong>{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>
                    <p>{subcategory.subdesch1}</p>


                    <div className="Subcategory-details">


                      <p>{subcategory.subdesc}</p>

                      <h3>{subcategory.subtitle106}</h3>
                      <p>{subcategory.subdesc106}</p>
                      <h3>{subcategory.subtitle107}</h3>
                      <p>{subcategory.subdesc107}</p>
                      <p>{subcategory.description06}</p>
                      <p>{subcategory.description07}</p>
                      <h5>   <strong>{subcategory.heading1}</strong></h5>
                      <p>{subcategory.pragraph1}</p>
                      <h5>   <strong>{subcategory.heading2}</strong></h5>
                      <p>{subcategory.pragraph2}</p>
                      <h5>   <strong>{subcategory.heading3}</strong></h5>
                      <p>{subcategory.pragraph3}</p>
                      <h5>   <strong>{subcategory.heading4}</strong></h5>
                      <p>{subcategory.pragraph4}</p>
                      <h5>   <strong>{subcategory.heading5}</strong></h5>
                      <p>{subcategory.pragraph5}</p>
                      <h5>   <strong>{subcategory.heading6}</strong></h5>
                      <p>{subcategory.pragraph6}</p>
                      <h5> <strong>{subcategory.heading7}</strong></h5>
                      <p>{subcategory.pragraph7}</p>

                      <p>{subcategory.thirdParagraph}</p>

                      <h5>{subcategory.subtitle4}</h5>
                      <p>{subcategory.fourthParagraph}</p>

                      <h5>{subcategory.subtitle5}</h5>
                      <p>{subcategory.fifthParagraph}</p>
                      {/* Bullet points with bold start */}
                      <p><strong>{subcategory.pragraph1heading}</strong> {subcategory.headingbulletpo1} </p>
                      <ul>
                        {subcategory.headingBulletpoints && subcategory.headingBulletpoints.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <h6>{boldPart}</h6>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <h5>   <strong>{subcategory.headingf}</strong></h5>
                      <p>{subcategory.pragraph1f}</p>
                      <h5><strong>{subcategory.heading2f}</strong></h5>
                      <p>{subcategory.pragraph2f}</p>

                      <h5><strong>{subcategory.heading3f}</strong></h5>
                      <p>{subcategory.pragraph3f}</p>
                      <h5>   <strong>{subcategory.heading4f}</strong></h5>
                      <p>{subcategory.pragraph4f}</p>
                      <h5>{subcategory.subtitle56}</h5>
                      <ul>
                        {subcategory.bulletPoints && subcategory.bulletPoints.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <strong>{boldPart}:</strong>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>

                      <h5>{subcategory.subtitle17c}</h5>
                      <ul>
                        {subcategory.bulletPoints17c && subcategory.bulletPoints17c.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <li>{boldPart}</li>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>

                      <h5>{subcategory.subtitle0s}</h5>
                      <ul>
                        {subcategory.bulletPoints0s && subcategory.bulletPoints0s.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <h7>{boldPart}:</h7>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <h4><strong>{subcategory.subtitle17svt}</strong></h4>

                      <ul>
                        {subcategory.bulletPoints17st && subcategory.bulletPoints17st.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <>{boldPart}</>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <p>{subcategory.subpragraph}</p>
                      <h6>{subcategory.headingth}</h6>
                      <h6>{subcategory.subtitleth}</h6>

                      <ul>
                        {subcategory.bulletPoints23th && subcategory.bulletPoints23th.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <strong>{boldPart}</strong>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <p>{subcategory.pragraphth1}</p>
                       <strong>{subcategory.subtitleth2}</strong>
                        <ul>
                        {subcategory.bulletPoints23th1 && subcategory.bulletPoints23th1.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              <>{boldPart}</>{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>

                      <strong>{subcategory.pragHead2}</strong>
                      <h6> <strong>{subcategory.pragHead3}</strong></h6>
                      <h6><strong>{subcategory.pragHead4}</strong></h6>
                      <a href={subcategory.Linkssss}>{subcategory.Linkssss}</a>


                      <strong>{subcategory.subtitle6}</strong>
                      <p>{subcategory.sixthParagraph}</p>

                      <ul>
                        {subcategory.bulletPoints6 && subcategory.bulletPoints6.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              {boldPart}{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <strong>{subcategory.subtitle0sm}</strong>
                      <p>{subcategory.sixthParagraph}</p>
                      {/* Bullet points with bold start */}
                      <ul>
                        {subcategory.bulletPoints0smm && subcategory.bulletPoints0smm.map((item, index) => (
                          <li key={index}>
                            <strong>{item.title}:</strong> {item.description}
                            <ul>
                              {item.points.map((point, i) => (
                                <li key={i}>{point}</li>
                              ))}
                            </ul>
                          </li>
                        ))}
                      </ul>
                      <strong>{subcategory.subtitles1sm}</strong>
                      <p>{subcategory.discription1sm}</p>
                      <strong>{subcategory.subtitles2sm}</strong>
                      <p>{subcategory.discription2sm}</p>
                      <strong>{subcategory.subtitles3sm}</strong>
                      <p>{subcategory.discription3sm}</p>
                      <strong>{subcategory.subtitles4sm}</strong>
                      <p>{subcategory.discription4sm}</p>
                      <strong>{subcategory.subtitles5sm}</strong>


                      {/*                 
                      <div style={{
                        maxWidth: '800px',
                        margin: '30px auto',
                        padding: '20px',
                        border: '1px solid #ddd',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                      }}>

               
                        {(() => {
                          const extractYouTubeEmbedLink = (url) => {
                            try {
                              const parsed = new URL(url);
                              if (parsed.hostname.includes("youtu.be")) {
                                return `https://www.youtube.com/embed/${parsed.pathname.slice(1)}`;
                              }
                              const v = parsed.searchParams.get("v");
                              if (v) {
                                return `https://www.youtube.com/embed/${v}`;
                              }
                              if (url.includes("embed/")) {
                                return url;
                              }
                            } catch {
                              return "";
                            }
                            return "";
                          };

                          const embedLink = extractYouTubeEmbedLink(subcategory.videoLink);

                          return embedLink ? (
                            <div style={{
                              position: 'relative',
                              paddingBottom: '56.25%',
                              height: 0,
                              overflow: 'hidden',
                              borderRadius: '8px'
                            }}>
                              <iframe
                                src={embedLink}
                                title="Subcategory Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: '100%',
                                  height: '100%',
                                  border: 'none',
                                }}
                              ></iframe>
                            </div>
                          ) : (
                            <p style={{ textAlign: 'center', color: '#888' }}>No videos available.</p>
                          );
                        })()}

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                          <a
                            href={subcategory.companyLink || "#"}
                            target={subcategory.companyLink ? "_blank" : "_self"}
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: 'none',
                              pointerEvents: subcategory.companyLink ? 'auto' : 'none'
                            }}
                          >
                            <button
                              disabled={!subcategory.companyLink}
                              style={{
                                padding: '10px 24px',
                                fontSize: '16px',
                                backgroundColor: subcategory.companyLink ? '#007bff' : '#ccc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: subcategory.companyLink ? 'pointer' : 'not-allowed',
                                transition: 'background-color 0.3s',
                              }}
                              onMouseOver={(e) => {
                                if (subcategory.companyLink) e.target.style.backgroundColor = '#0056b3';
                              }}
                              onMouseOut={(e) => {
                                if (subcategory.companyLink) e.target.style.backgroundColor = '#007bff';
                              }}
                            >
                              {subcategory.buttons || "Visit Company"}
                            </button>
                          </a>
                        </div>
                      </div> */}

                      {/* {(subcategory.videoLink || subcategory.companyLink) && (
                        <div style={{
                          maxWidth: '800px',
                          margin: '30px auto',
                          padding: '20px',
                          border: '1px solid #ddd',
                          borderRadius: '12px',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                          backgroundColor: '#fff',
                        }}>

                          {subcategory.videoLink && (() => {
                            const extractYouTubeEmbedLink = (url) => {
                              try {
                                const parsed = new URL(url);
                                if (parsed.hostname.includes("youtu.be")) {
                                  return `https://www.youtube.com/embed/${parsed.pathname.slice(1)}`;
                                }
                                const v = parsed.searchParams.get("v");
                                if (v) {
                                  return `https://www.youtube.com/embed/${v}`;
                                }
                                if (url.includes("embed/")) {
                                  return url;
                                }
                              } catch {
                                return "";
                              }
                              return "";
                            };

                            const embedLink = extractYouTubeEmbedLink(subcategory.videoLink);

                            return embedLink ? (
                              <div style={{
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: 0,
                                overflow: 'hidden',
                                borderRadius: '8px',
                                marginBottom: '20px',
                              }}>
                                <iframe
                                  src={embedLink}
                                  title="Subcategory Video"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowFullScreen
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                  }}
                                ></iframe>
                              </div>
                            ) : null;
                          })()}

                         
                          {subcategory.companyLink && (
                            <div style={{ textAlign: 'center' }}>
                              <a
                                href={subcategory.companyLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none' }}
                              >
                                <button
                                  style={{
                                    padding: '10px 24px',
                                    fontSize: '16px',
                                    backgroundColor: '#f0800f',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                  }}
                                  onMouseOver={(e) => { e.target.style.backgroundColor = '#f0800f'; }}
                                  onMouseOut={(e) => { e.target.style.backgroundColor = '#f0800f'; }}
                                >
                                  {subcategory.buttons || "Visit Company website"}
                                </button>
                              </a>
                            </div>
                          )}

                        </div>
                      )} */}
                      <div
                        style={{
                          flexWrap: 'wrap',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'stretch',
                          rowGap: '0px',
                          columnGap: '0px',
                        }}
                      >
                        {/* Video Section */}
                        {Array.isArray(subcategory.videoLink) && subcategory.videoLink.length > 0 && (
                          <div
                            style={{
                              flex: '2 1 600px',
                              minWidth: '300px',
                              maxWidth: '100%',
                              padding: '20px',
                              borderRadius: '12px',
                              backgroundColor: '#fff',
                              boxSizing: 'border-box',
                            }}
                          >
                            {subcategory.videoLink.map((link, index) => {
                              const videoId = extractVideoId(link);
                              if (!videoId) return null;
                              const embedLink = `https://www.youtube.com/embed/${videoId}`;

                              return (
                                <div
                                  key={index}
                                  style={{
                                    position: 'relative',
                                    paddingBottom: '56.25%',
                                    height: 0,
                                    overflow: 'hidden',
                                    borderRadius: '10px',
                                    marginBottom: index !== subcategory.videoLink.length - 1 ? '16px' : '0',
                                  }}
                                >
                                  <iframe
                                    src={embedLink}
                                    title={`Video ${index + 1}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      border: 'none',
                                    }}
                                  ></iframe>
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* Button Section */}
                        {subcategory.companyLink1 && subcategory.companyLink1.trim() !== '' && (
                          <div
                            style={{
                              flex: '1 1 280px',
                              maxWidth: '300px',
                              minWidth: '250px',
                              padding: '20px',
                              borderRadius: '12px',
                              backgroundColor: '#fff',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              boxSizing: 'border-box',
                              marginBottom: "23px"
                            }}
                          >
                            <a
                              href={subcategory.companyLink1}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                pointerEvents: 'auto',
                                textDecoration: 'none',
                                width: '100%',
                              }}
                            >
                              <button
                                style={{
                                  width: '100%',
                                  height: '60px',
                                  fontSize: '17px',
                                  backgroundColor: '#f0800f',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '10px',
                                  cursor: 'pointer',
                                  transition: 'background-color 0.3s',
                                }}
                                onMouseOver={(e) => {
                                  e.target.style.backgroundColor = '#f0800f';
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.backgroundColor = '#f0800f';
                                }}
                              >
                                {subcategory.buttons}
                              </button>
                            </a>
                          </div>
                        )}
                      </div>


                      <h5>{subcategory.subtitle7}</h5>
                      <p>{subcategory.seventhParagraph}</p>

                      {/* Bullet points with bold start */}
                      <ul>
                        {subcategory.bulletPoints7 && subcategory.bulletPoints7.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              {boldPart}{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>
                      <h5>{subcategory.subject01}</h5>
                      <p>{subcategory.subjectdescriptions}</p>
                      <p>{subcategory.subjectdescriptions01}</p>
                      <h5>{subcategory.subject02}</h5>
                      <p>{subcategory.subjectdescriptions02}</p>
                      <h5>{subcategory.subject03}</h5>
                      <p>{subcategory.subjectdescriptions03}</p>
                      <h5>{subcategory.subject04}</h5>
                      <p>{subcategory.subjectdescriptions04}</p>
                      <h5>{subcategory.subtitle8}</h5>
                      <p>{subcategory.eightParagraph}</p>

                      {/* Bullet points with bold start */}
                      <ul>
                        {subcategory.bulletPoints8 && subcategory.bulletPoints8.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              {boldPart}{rest.join(':')}

                            </li>
                          );
                        })}
                      </ul>





                      <h5>{subcategory.subtitle9}</h5>
                      <p>{subcategory.ninethParagraph}</p>



                      {/* Bullet points with bold start */}
                      <ul>
                        {subcategory.bulletPoints9 && subcategory.bulletPoints9.map((point, index) => {
                          const [boldPart, ...rest] = point.split(':');
                          return (
                            <li key={index}>
                              {boldPart}{rest.join(':')}
                            </li>
                          );
                        })}
                      </ul>

                      <h5>{subcategory.subtitle9}</h5>
                      <p>{subcategory.ninethParagraph}</p>




                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Subcategory-products">
              <div className="Subcategory-products-box">
                <span>{subcategory.subcategory} products</span>
                <h3>Products</h3>
                <div className="subcategory-categories">
                  {subcategory.Products.map((i) => (
                    <Link to={{
                      pathname: `/productdetail/${formatPathname(i.title)}/`
                    }} onClick={scrollToTop} key={i.id}>
                      <div className="Subcategory-categories-card">
                        <img src={i.cover} alt="" />
                        <div className="Subcategory-card-detail">
                          <h2>{i.title}</h2>
                          <p> {i.description.split(' ').slice(0, 18).join(' ')}
                            {i.description.split(' ').length > 18 && '...'}</p>
                          <div className="subcategory-btn">
                            <p>view detail</p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </>
        ))}
    </div>
  )
}
export default Subcategory
